module.exports = __webpack_public_path__ + "static/media/r-md8.c0998724.png";